export const HEALTH_CHECK = 'HEALTH_CHECK';
export const DELAY = 10000;
export const INITIAL_DELAY = 500;
